export default {
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
  ApiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  communicationBaseUrl: process.env.VUE_APP_COMMUNICATION_BASE_URL,
}
